import { transformPhoneToDto } from '@http/service/shared-transformers'
import { SimplePersonFormModel } from '@shared/components/forms/shared/simple-person-form/model'
import { getMarketingData } from '@shared/pipes/marketing-data'

export const transformPartnerFormToDto = (form: SimplePersonFormModel) => ({
	name: form.name,
	phone: transformPhoneToDto(form.phone),
	email: form.email,
	marketingData: getMarketingData(),
})
